module.exports = __webpack_public_path__ + "static/media/undead.72f441f1.png";